import { render, staticRenderFns } from "./ContactFields.vue?vue&type=template&id=23b64b37&scoped=true&"
import script from "./ContactFields.vue?vue&type=script&lang=js&"
export * from "./ContactFields.vue?vue&type=script&lang=js&"
import style0 from "./ContactFields.vue?vue&type=style&index=0&id=23b64b37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b64b37",
  null
  
)

export default component.exports